import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";
import { TaskOption } from "./TaskOption";

export class EnrolmentTask {
    private storedLanguage = window.sessionStorage.getItem("selectedLanguage");
    private translate: Translator = new Translator(this.storedLanguage || "en");

    constructor(translate: Translator) {
        this.translate = translate;
    }

    ENROL_CARD: TaskOption = { id: 1, value: "fld_enrol_card", label: this.translate.byKey(TranslationKeys.enrolCard) };
    ENROL_MOBILE_CREDENTIAL: TaskOption = { id: 2, value: "fld_enrol_mobile", label: this.translate.byKey(TranslationKeys.enrolMobile) };
    ENROL_FINGERPRINT: TaskOption = { id: 3, value: "fld_enrol_fingerprint", label: this.translate.byKey(TranslationKeys.enrolFinger) };
    ENROL_HAND: TaskOption = { id: 4, value: "fld_enrol_hand", label: this.translate.byKey(TranslationKeys.enrolHand) };
    ENROL_FACE: TaskOption = { id: 5, value: "fld_enrol_face", label: this.translate.byKey(TranslationKeys.enrolFace) };
    ENROL_QR_CODE: TaskOption = { id: 6, value: "fld_enrol_qr_code", label: this.translate.byKey(TranslationKeys.enrolQrCode) };
    ENCODE_CARD: TaskOption = { id: 7, value: "fld_encode_card", label: this.translate.byKey(TranslationKeys.encodeCard) };
    ALL_ENROLMENT_TASK: TaskOption[] = [this.ENROL_CARD, this.ENROL_MOBILE_CREDENTIAL, this.ENROL_FINGERPRINT, this.ENROL_HAND, this.ENROL_FACE, this.ENROL_QR_CODE, this.ENCODE_CARD];
}
